import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { TourCoach } from "@/components/product-tour/TourCoach";
import { useAuthStore } from "@/stores/auth";
import { useDemoWorkspaceStore } from "@/stores/demoWorkspace";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export function PublicLayout() {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const demoActive = useDemoWorkspaceStore((s) => s.active);

  // A restored demo must verify its account before public timetable queries
  // mount. ProtectedRoute covers signed-in pages; marketing pages hydrate
  // their prerendered content independently of authentication.
  if (demoActive && isLoading) {
    return <div className="tour-loading" role="status">Loading Trace…</div>;
  }

  return (
    <div className="min-h-screen bg-bg text-ink">
      {user && <div className="flex justify-end border-b border-line-2 px-4 py-2"><Link to="/learn" className="tour-launcher"><Compass size={15} />Explore Trace</Link></div>}
      <TourCoach />
      <Outlet />
      <Toaster theme="dark" position="bottom-right" />
      <footer className="border-t border-line-2 px-6 py-4 text-center">
        <p className="flex items-center justify-center gap-1.5 text-xs text-ink-4">
          Powered by
          <a href="/" className="inline-flex transition-opacity hover:opacity-80">
            <img src="/trace-logo.svg" alt="TRACE" className="h-3" />
          </a>
          — Festival Intelligence
        </p>
      </footer>
    </div>
  );
}
